import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { AnimatedButton, Button, Glyphicon, ItemCard, Link, Panel, Text, SubHeading } from 'reaxl';

/**
 *  The PromoCard component renders a card with either an icon/image and an optional button
 */
function PromoCard(_ref) {
  var _Fragment;
  let {
    animatedButton = false,
    animatedButtonState = '',
    bodyClassName,
    buttonStyle = {},
    buttonText = '',
    children,
    className,
    handleButtonClick = () => {},
    heading,
    header,
    href,
    iconClassnames = '',
    iconName = '',
    imgHeight = '',
    imgWidth = '',
    imgSrc = '',
    inputComponent,
    orientation = 'portrait',
    panelClassName,
    subText = '',
    uiContext = 'default',
    ...rest
  } = _ref;
  const isSpotlightCard = uiContext === 'spotlight';
  const isLandscape = orientation === 'landscape';
  const imgClassNames = clsx({
    'img-responsive center-block': !imgHeight
  }, 'text-center');
  const renderIconOrImage = imgSrc ? /*#__PURE__*/_jsx("div", {
    width: imgWidth,
    height: imgHeight
  }, void 0, /*#__PURE__*/_jsx("img", {
    height: imgHeight,
    width: imgWidth,
    src: imgSrc,
    alt: "",
    className: imgClassNames
  })) : /*#__PURE__*/_jsx(Glyphicon, {
    className: iconClassnames,
    glyph: iconName
  });
  const buttonProps = {
    bsStyle: 'secondary',
    onClick: handleButtonClick,
    style: buttonStyle,
    className: clsx({
      'btn btn-secondary': href,
      'margin-vertical-4': isLandscape,
      'margin-top-5': !isLandscape
    })
  };
  const renderButton = () => {
    if (animatedButton) {
      return /*#__PURE__*/React.createElement(AnimatedButton, Object.assign({
        buttonState: animatedButtonState,
        buttonText: buttonText,
        key: "animated-button"
      }, buttonProps));
    }
    if (href) {
      return /*#__PURE__*/React.createElement(Link, Object.assign({
        key: "text-button"
      }, buttonProps, {
        href: href
      }), buttonText);
    }
    return /*#__PURE__*/React.createElement(Button, Object.assign({
      key: "text-button"
    }, buttonProps), buttonText);
  };
  const bodyWrapper = body => /*#__PURE__*/_jsx("div", {
    className: bodyClassName,
    style: isLandscape ? {
      maxWidth: '468px'
    } : {}
  }, void 0, body);
  const renderBody = () => {
    if (typeof subText !== 'string') {
      return bodyWrapper(subText);
    }
    return bodyWrapper(_Fragment || (_Fragment = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Text, {
      className: "margin-top-4",
      weight: "light",
      size: 300,
      color: "subdued"
    }, void 0, subText), children)));
  };
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className,
    "data-cmp": "cntnr-promo-card"
  }, rest), /*#__PURE__*/_jsx(Panel, {
    bsStyle: uiContext === 'wallet' ? 'primary' : 'default',
    className: clsx({
      'border-0 bg-brand-secondary': isSpotlightCard,
      'inventory-listing': !isSpotlightCard,
      'display-flex justify-content-center align-items-center': !header
    })
  }, void 0, header && /*#__PURE__*/_jsx(Panel.Heading, {
    className: "display-flex justify-content-center"
  }, void 0, header), /*#__PURE__*/_jsx(Panel.Body, {
    className: clsx(panelClassName, {
      'text-center': !isLandscape
    })
  }, void 0, /*#__PURE__*/_jsx(ItemCard, {
    sideBar: renderIconOrImage,
    header: /*#__PURE__*/_jsx(SubHeading, {
      className: "margin-vertical-4",
      size: 500,
      color: "primary"
    }, void 0, heading),
    body: renderBody(),
    footer: buttonText && renderButton(),
    orientation: orientation
  }))));
}
export default PromoCard;